import { Component } from 'vue'
import ErrorBlock from '~/components/blocks/ErrorBlock.vue'
import { type TBlockReference } from '~/types/block-types'
import { useAllBlock } from '~/composables/useAllBlocks'

// return the correct block (component) or an error block.
export const useBlock = function (reference: TBlockReference): Component {
  const blocks = useAllBlock()
  const blockDefinition = blocks.value[reference.collection]

  return (blockDefinition && blockDefinition.component) ? blockDefinition.component : ErrorBlock
}
